<template>
  <div>
		<banner-plan />
		<section-plans-grauitous />
		<section-sales-channels />
		<section-digital-allies />
		<section-integral-management />
		<company-data />
		<app-footer />
	</div>  
</template>

<script>
import bannerPlan from '@/components/home-new/banner-plan';
import companyData from '@/components/home-new/company-data';
import appFooter from '@/components/home-new/app-footer';
import sectionSalesChannels from '@/components/home-new/section-sales-channels';
import sectionDigitalAllies from '@/components/home-new/section-digital-allies';
import sectionPlansGrauitous from '@/components/home-new/section-plans-grauitous';
import sectionIntegralManagement from '@/components/home-new/section-integral-management';

export default {
	name: 'page-plan-gratuitous',
	components: {
		bannerPlan,
		companyData,
		appFooter,
		sectionSalesChannels,
		sectionDigitalAllies,
		sectionIntegralManagement,
		sectionPlansGrauitous,
	},
};
</script>


// WEBPACK FOOTER //
// src/pages/page-plan-gratuitous.vue